<template>
  <div class="store">
    <div class="store__search">
      <div @click="clickParcel" class="sort__btn vertical-align pointer select">
        <span :class="{ middle: true, active__search: activeSearch == 'parcel' }">包邮金额</span>
        <img class="middle sort__icon" :src="parcel" />
      </div>
      <div @click="clickDelivery" class="sort__btn vertical-align pointer select">
        <span :class="{ middle: true, active__search: activeSearch == 'delivery' }">起送金额</span>
        <img class="middle sort__icon" :src="delivery" />
      </div>
      <el-select
        v-model="searchParams.minDeliveryAmountType"
        class="ml8"
        size="mini"
        clearable
        placeholder="起送金额"
        @change="changeGetStoreList"
      >
        <el-option
          v-for="item in minDeliveryAmountType"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectShopTags"
        multiple
        collapse-tags
        class="ml8"
        size="mini"
        placeholder="优质服务"
        @visible-change="selectTagsChange"
        @remove-tag="changeGetStoreList"
      >
        <el-option v-for="tag in shopTags" :key="tag" :label="tag" :value="tag"></el-option>
      </el-select>
      <!-- 目前只有特价活动直接写死 -->
      <el-checkbox-group style="display: inline-block" v-model="selectShopActivityTags" @change="selectTagsChange">
        <el-checkbox label="ACTIVITY">特价活动</el-checkbox>
      </el-checkbox-group>
      <!-- <el-select
        v-model="searchParams.shopActivityCodes"
        multiple
        collapse-tags
        class="ml8"
        size="mini"
        placeholder="优惠活动"
        @visible-change="selectTagsChange"
        @remove-tag="changeGetStoreList"
      >
        <el-option
          v-for="tag in shopActivityTags"
          :key="tag.activityTypeCode"
          :label="tag.activityType"
          :value="tag.activityTypeCode"
        ></el-option>
      </el-select> -->
    </div>
    <div class="store__list">
      <StoreItem @go-store="linkTo" :store="store" v-for="store in storeList" :key="store.storeId" />
      <el-pagination
        style="text-align: right"
        @current-change="handleCurrentChange"
        :current-page="searchParams.pageNum"
        :page-size="searchParams.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="storeList.length"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import { mapState } from 'vuex';
import StoreItem from './StoreItem';

const upToLowActive = require('@/assets/search/up-to-low-active.png');
const lowToUpActive = require('@/assets/search/low-to-up-active.png');
const upToLow = require('@/assets/search/up-to-low.png');
const lowToUp = require('@/assets/search/low-to-up.png');

export default {
  components: { StoreItem },
  computed: {
    ...mapState('SEARCH', {
      searchText: state => state.searchText
    }),
    parcel() {
      if (this.activeSearch == 'parcel') {
        return this.sortParcel ? upToLowActive : lowToUpActive;
      } else {
        return this.sortParcel ? upToLow : lowToUp;
      }
    },
    delivery() {
      if (this.activeSearch == 'delivery') {
        return this.sortDelivery ? upToLowActive : lowToUpActive;
      } else {
        return this.sortDelivery ? upToLow : lowToUp;
      }
    }
  },
  data() {
    return {
      // 配送、包邮筛选条件
      activeSearch: '',
      sortParcel: false,
      sortDelivery: false,
      // 店铺列表
      storeList: [],
      // 搜索参数
      searchParams: {
        keyword: '',
        shopTags: null,
        shopActivityCodes: null,
        minDeliveryAmountType: null,
        sortCode: null,
        pageNum: 1,
        pageSize: 10
      },
      // 多选标签
      shopTags: [],
      selectShopTags: [],
      shopActivityTags: [],
      selectShopActivityTags: [],
      // 起送金额类型
      minDeliveryAmountType: [
        {
          value: 0,
          label: '0-300'
        },
        {
          value: 1,
          label: '300-500'
        },
        {
          value: 2,
          label: '500-1000'
        },
        {
          value: 3,
          label: '1000以上'
        }
      ]
    };
  },
  methods: {
    linkTo(shopId) {
      this.$router.push({ path: `/store/${shopId}/homePage` });
    },
    clickParcel() {
      if (this.activeSearch == 'parcel') {
        this.sortParcel = !this.sortParcel;
        this.searchParams.sortCode = this.sortParcel ? 2 : 1;
        this.changeGetStoreList();
        return;
      }
      this.searchParams.sortCode = this.sortParcel ? 2 : 1;
      this.activeSearch = 'parcel';
      this.changeGetStoreList();
    },
    clickDelivery() {
      if (this.activeSearch == 'delivery') {
        this.sortDelivery = !this.sortDelivery;
        this.searchParams.sortCode = this.sortDelivery ? 4 : 3;
        this.changeGetStoreList();
        return;
      }
      this.searchParams.sortCode = this.sortDelivery ? 4 : 3;
      this.activeSearch = 'delivery';
      this.changeGetStoreList();
    },
    async getList() {
      this.searchParams.shopTags = this.selectShopTags.join();
      this.searchParams.shopActivityCodes = this.selectShopActivityTags.join();
      const params = {
        ...this.searchParams,
        keyword: this.searchText || null,
        shopTags: this.searchParams.shopTags || null,
        shopActivityCodes: this.searchParams.shopActivityCodes || null
      };
      const { data, shopTags, shopActivityTags } = await api.shop.getStoreList(params);
      this.storeList = data || [];
      this.shopTags = shopTags;
      this.shopActivityTags = shopActivityTags;
    },
    // 条件变更时获取新的店铺列表
    changeGetStoreList() {
      this.searchParams.pageNum = 1;
      this.getList();
    },
    // selectTagsChange(selecting) {
    //   if (selecting) return;
    //   this.changeGetStoreList();
    // },
    selectTagsChange() {
      this.changeGetStoreList();
    },
    handleCurrentChange(pageNum) {
      this.searchParams.pageNum = pageNum;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.store {
  &__search {
    height: 48px;
    margin-top: 12px;
    padding: 10px 16px;
    background: #f5f5f5;
    border: 1px solid #eeeeee;
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      font-weight: 400;
      color: #595959;
    }

    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      font-weight: 400;
      color: #595959;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      font-weight: 400;
      color: #595959;
    }
  }
  .sort {
    &__search {
      display: inline-block;
      height: 30px;
      padding: 8px 12px;
      font-size: 12px;
      line-height: 1;
      background: #ffffff;
      border: 1px solid #dedede;
    }
    &__btn {
      display: inline-block;
      height: 28px;
      padding: 7px 12px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 12px;
      border: 1px solid #dedede;
      background: #ffffff;
      &:hover {
        color: #1e8dff;
        border-color: #1e8dff;
      }
    }
  }
  .sort__btn + .sort__btn {
    margin-left: 8px;
  }
  .active__search {
    color: #1e8dff;
  }
  .sort__icon {
    width: 6px;
    height: 12px;
  }
  .el-button + .el-button {
    margin-left: 8px;
  }
  .ml8 {
    margin-left: 8px;
  }
  ::v-deep .el-button--mini {
    height: 28px;
  }
  ::v-deep .el-input__inner {
    height: 28px !important;
    border: none;
    background: transparent;
  }
  ::v-deep .el-cascader__search-input {
    background: #f5f5f5;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
  }
}
</style>
